import { render, staticRenderFns } from "./RegionDataDiv.vue?vue&type=template&id=74ec44de&scoped=true&"
import script from "./RegionDataDiv.vue?vue&type=script&lang=js&"
export * from "./RegionDataDiv.vue?vue&type=script&lang=js&"
import style0 from "./RegionDataDiv.vue?vue&type=style&index=0&id=74ec44de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ec44de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VAvatar,VBtn,VCard,VCol,VContainer,VDialog,VIcon,VImg,VListItemSubtitle,VListItemTitle,VRow,VSpacer,VSystemBar})
